import { useState } from 'react';
import GridLayout, { WidthProvider } from 'react-grid-layout';
import { Page } from '@/components/page';
import { Toggle } from '@/components/toggle';
import { GridPanel } from '@/components/grid-panel';
import { SchemasListWidget } from '@/features/schemas/components/schemas-list-widget';
import { SchemaDetailsWidget } from '@/features/schemas/components/schema-details-widget';
import { SchemaEditorWidget } from '@/features/schemas/components/schema-editor-widget';
import { useTabId } from '@/hooks/use-tab-id';
import { useScreenId } from '@/hooks/use-screen-id';

const layout = [
  { i: 'list', x: 0, y: 0, w: 25, h: 20 },
  { i: 'details', x: 25, y: 0, w: 15, h: 20 },
  { i: 'editor', x: 0, y: 20, w: 40, h: 30 },
];

const AutoWidthGridLayout = WidthProvider(GridLayout);

export function FormEditor() {
  const [isDraggable, setIsDraggable] = useState(false);
  const tabId = useTabId();
  const screenId = useScreenId();

  if (!tabId || !screenId) return null;

  const idPrefix = `${tabId}/${screenId}`;

  return (
    <Page
      title="Schemas"
      toolbar={
        <Toggle
          enabled={isDraggable}
          label="Enable drag"
          onChange={setIsDraggable}
        />
      }
    >
      <AutoWidthGridLayout
        className="layout"
        layout={layout}
        cols={40}
        rowHeight={30}
        isDraggable={isDraggable}
      >
        <GridPanel key="list">
          <SchemasListWidget id={`${idPrefix}/list`} />
        </GridPanel>
        <GridPanel key="details">
          <SchemaDetailsWidget id={`${idPrefix}/details`} />
        </GridPanel>
        <GridPanel key="editor">
          <SchemaEditorWidget id={`${idPrefix}/editor`} />
        </GridPanel>
      </AutoWidthGridLayout>
    </Page>
  );
}
